import type {SelectItem} from '@jetbrains/ring-ui/components/select/select'
import {useContext} from 'react'

import {useAppDispatch, useAppSelector} from '../../../../../../../../../../hooks/react-redux'
import {emptyArray} from '../../../../../../../../../../utils/empty'
import {DisabledContext} from '../../../../../../../contexts/DisabledContext'
import {usePipelineId} from '../../../../../../../hooks/pipeline'

import {jobDependencySelectItems} from './JobDependency.consts'

import {
  getDraftJobs,
  getJobName,
} from 'src/components/pages/PipelinesPages/EditPipelinePage/EditPipelinePage.selectors'
import {
  hoveredJob,
  pipelineDraft,
} from 'src/components/pages/PipelinesPages/EditPipelinePage/slices/EditPipelinePage.slices'

function useJobDependency(jobId: string, dependencyId: string) {
  const dispatch = useAppDispatch()
  const [allFiles, notUseFiles] = jobDependencySelectItems
  const pipelineId = usePipelineId()
  const dependencyFilesPublication = useAppSelector(
    state =>
      getDraftJobs(state, pipelineId)?.[dependencyId]?.['files-publication']?.join('\n') ?? '',
  )
  const handlerJobDependencySelect = (value: SelectItem | null) => {
    const {key} = value || {}
    const isAddAllFiles = key === allFiles.key
    const files = isAddAllFiles ? dependencyFilesPublication.split('\n') : []

    dispatch(
      pipelineDraft.actions.setFilesDependencies({
        id: pipelineId,
        jobId,
        dependencyId,
        files,
      }),
    )
  }
  const isJobDependencyDisabled = useContext(DisabledContext)
  const handlerJobDependencyMouseHover = (id: string | null) => () =>
    dispatch(hoveredJob.actions.set(id))
  const dependencyName =
    useAppSelector(state => getJobName(state, pipelineId, dependencyId)) ?? 'Unnamed job'
  const artifactDependencies = useAppSelector(state => {
    const dependencies = getDraftJobs(state, pipelineId)?.[jobId]?.dependencies ?? []
    for (const dependency of dependencies) {
      if (typeof dependency === 'object' && dependencyId in dependency) {
        return dependency[dependencyId].files ?? emptyArray
      }
    }
    return emptyArray
  })
  const hasDependencyFilesPublication = Boolean(dependencyFilesPublication.length)
  const hasArtifactDependencies = Boolean(artifactDependencies.length)
  const selectedJobDependencyItem = hasArtifactDependencies ? allFiles : notUseFiles

  return {
    dependencyName,
    hasDependencyFilesPublication,
    selectedJobDependencyItem,
    artifactDependencies,
    isJobDependencyDisabled,
    handlerJobDependencySelect,
    handlerJobDependencyMouseHover,
  }
}

export default useJobDependency
